<template>
    <b-row class="main-header" >
    <div class="mobile-menu">
        <a class="main-logo" href="/main">
        <img src="../assets/img/epaveldas-logo.svg" alt="ePaveldas logotipas">
        </a>
        <a class="apache-jena" href="https://jena.apache.org">
        <img src="../assets/logo.svg" alt="Apache Jena logotipas">
        <span>Apache Jena</span>
        </a>
    </div>
    </b-row>
</template>

<script>
export default {
  name: 'VepisHeader'
}
</script>

<style scoped>
.main-header {
  background-color: var(--colorPrimary);
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1100;
}

.mobile-menu {
    align-items: center;
    background: linear-gradient(180deg,var(--colorPrimary),var(--colorPrimary--dark));
    display: flex;
    padding: 15px 30px;
    z-index: 200;
}

a.main-logo {
    color: #007bff;
    text-decoration: none;
    background-color: transparent;
}

.main-logo img {
    height: 32px;
    vertical-align: top;
    border: 0;
}

a.apache-jena {
    margin-left: auto;
    align-items: center;
    display: flex;
    color: lightgray;
    flex-direction: row;
    justify-content: flex-end;
    max-width: 320px;
    position: relative;
}

.apache-jena img {
    height: 24px;
    vertical-align: bottom;
    border: 0;
}
</style>
